import { OUTCOME_CATEGORY_PERFORMANCE_EXPECTATIONS } from 'global/constants';
import { Outcome } from 'approot/shared/outcomes/outcome.constants';
import {
  OutcomeButton,
  OutcomeList,
  OutcomePill,
} from './outcomes-shared.style';

export const UnitOutcomesList = ({
  outcomes,
  setOutcome,
  hasPerformanceExpectations,
}: {
  outcomes: Outcome[];
  setOutcome: (outcome: Outcome) => void;
  hasPerformanceExpectations?: boolean;
}) => {
  return (
    <>
      {outcomes.map(outcome => (
        <OutcomeList key={outcome.code}>
          <li>
            {hasPerformanceExpectations ? (
              <OutcomeButton
                type="button"
                aria-label={`Outcome: ${outcome.code}`}
                aria-haspopup="dialog"
                onClick={() => setOutcome(outcome)}
              >
                {outcome.category !== OUTCOME_CATEGORY_PERFORMANCE_EXPECTATIONS
                  ? outcome.name
                  : outcome.code}
              </OutcomeButton>
            ) : (
              <OutcomePill
                type="button"
                aria-label={`Outcome: ${outcome.code}`}
                aria-haspopup="dialog"
                onClick={() => setOutcome(outcome)}
              >
                {outcome.code}
              </OutcomePill>
            )}
          </li>
        </OutcomeList>
      ))}
    </>
  );
};
